let arrLeonardGTMTrackingFormPath = [
    '/infolettre/'
];
let baseFacebookShare = 'https://www.facebook.com/share.php?u=';
let basePinterestShare = 'https://www.pinterest.com/pin/create/button/?description=Prochain%20arr%C3%AAt%3A%20Pinterest';
let lastScroll = 0;

jQuery(document).ready(function() {
    initialise();
});

function initialise() {
    initLeonardGTMTracking();
    djdmvChangeMenuOnScroll();

    jQuery(window).scroll(function() {
        djdmvChangeMenuOnScroll();
    });

    if(jQuery('.menu-mobile-container .icon-menu').length > 0) {
        jQuery('.menu-mobile-container .icon-menu').on('click', function(){
            jQuery('body').toggleClass('open-menu');
        });

        jQuery('.menu-main-mobile > .menu-item-has-children > a').on('click', function(event){
            event.preventDefault();
            jQuery(this).parent('.menu-item-has-children').toggleClass('sub-open');

            if(jQuery('.menu-main-mobile .menu-item-has-children').hasClass('sub-open')) {
                jQuery('.menu-mobile').addClass('open-sub');
            }
            else {
                jQuery('.menu-mobile').removeClass('open-sub');
            }
        });
    }

    if(jQuery('.menu-search').length > 0) {
        jQuery('.menu-search').on('click', function(e){
            event.preventDefault();
            jQuery('.search').toggleClass('hidden');
        });
    }
    
    if(jQuery('.menu-mobile-search').length > 0) {
        jQuery('.menu-mobile-search').on('click', function(e){
            event.preventDefault();
            jQuery('.mobile-search').toggleClass('hidden');
        });
    } 

    if(jQuery('.intro-desktop h1').length > 0) {
        if(jQuery(window).width() <= 768) {
            jQuery('.intro-desktop h1').on('click', function(event){
                event.preventDefault();
                jQuery('.intro-description').toggleClass('hidden');
            });
        }
    }
    
    if(jQuery('.archive-posts .taxonomy-posts').length > 0) {
        jQuery('.archive-posts .taxonomy-viewer').each(function(){
            let firstTaxonomyContent = jQuery(this).closest('.archive-post').find('.taxonomy-post').first().html();
            let firstTaxonomyUrl = jQuery(this).closest('.archive-post').find('.taxonomy-post').first().data('url');
            let firstTaxonomySrc = jQuery(this).closest('.archive-post').find('.taxonomy-post').first().children('img').attr('src');

            jQuery(this).closest('.archive-post').find('.taxonomy-post').first().addClass('active-viewer');

            jQuery(this).empty().append(firstTaxonomyContent);
            jQuery(this).closest('.archive-post').find('.icon-arrow-right').attr('href', firstTaxonomyUrl);
            jQuery(this).closest('.archive-post').find('.stretched-link').attr('href', firstTaxonomyUrl);
            jQuery(this).closest('.archive-post').find('.social-facebook').attr('href', baseFacebookShare + firstTaxonomyUrl);
            jQuery(this).closest('.archive-post').find('.share-socials').append('<a class="icon icon-pinterest social-pinterest" target="_blank" rel="noopener" data-pin-do="buttonPin" data-pin-tall="true" data-pin-round="true" href="https://www.pinterest.com/pin/create/button/?description=Prochain%20arr%C3%AAt%3A%20Pinterest&url=' + firstTaxonomyUrl + '&media=' + firstTaxonomySrc + '"></a>');
            jQuery(this).closest('.archive-post').find('.share-socials').append('<a class="icon icon-email social-email" target="_blank" title="Courriel" href="mailto:?subject=Voici un lien à partager&amp;body=Veuillez prendre connaissance de ce lien:' + firstTaxonomyUrl + '"><span class="hidden">Courriel</span></a>');
        });

        jQuery('.archive-posts .taxonomy-post').on('click', djdmvChangeViewerImage);
    }

    if(jQuery('.slider-container').length > 0) {
        jQuery(window).resize(function(){
            let windowWidth = jQuery(window).width();

            if(windowWidth >= 1440) {
                let marginLeft = (windowWidth - 1340)/2;
                jQuery('.slider-container').css('margin-left', marginLeft);
            }
            else {
                jQuery('.slider-container').css('margin-left', 0);
            }
        });
    }

    if(jQuery('.relations-container').length > 0) {
        jQuery('.relations-container').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            variableWidth: true,
            prevArrow: '<a class="slick-nav slick-prev"><span class="hidden">Précédent</span></a>',
            nextArrow: '<a class="slick-nav slick-next"><span class="hidden">Suivant</span></a>'
        });

        sameHeight(jQuery('.relation-container .content-container'));
    }

    if(jQuery('.inspirations-container').length > 0) {
        jQuery('.inspirations-container').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            variableWidth: true,
            prevArrow: '<a class="slick-nav slick-prev"><span class="hidden">Précédent</span></a>',
            nextArrow: '<a class="slick-nav slick-next"><span class="hidden">Suivant</span></a>'
        });

        sameHeight(jQuery('.inspiration-container  .content-container'));
    }

    if(jQuery('.single-slider').length > 0) {
        jQuery('.single-slider').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '<a class="slick-nav slick-prev"><span class="hidden">Précédent</span></a>',
            nextArrow: '<a class="slick-nav slick-next"><span class="hidden">Suivant</span></a>'
        });
    }

    if(jQuery('.magazines-container').length > 0) {
        jQuery('.magazines-container').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            prevArrow: '<a class="slick-nav slick-prev"><span class="hidden">Précédent</span></a>',
            nextArrow: '<a class="slick-nav slick-next"><span class="hidden">Suivant</span></a>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                    }
                },
            ],
        });
    }
    
    if(jQuery('.anchor-navigation').length > 0) {
        jQuery('.anchor-navigation').on('click', djdmvAnchorNavigation);
    }

    if(jQuery('.single-inspiration .single-slider').length > 0) {
        jQuery('.single-inspiration .single-slider img').on('click', openInspirationModal);
    }

    if(jQuery('.inspirationModal .icon-container').length > 0) {
        jQuery('.inspirationModal .icon-container').on('mouseup', function() {
            jQuery(document).unbind('mouseup');

            jQuery('.inspirationModal').toggleClass('hidden');
            jQuery('body').toggleClass('modalOpen');
    
            jQuery('.inspirationModal .modal-slider').slick('unslick');
        });
    }

    if(jQuery('.mobile-taxonomy-container').length > 0) {
        jQuery('.mobile-taxonomy-container').on('click', function(event){
            event.preventDefault();
            jQuery(this).parent('.mobile-taxonomies-container').toggleClass('sub-open');
        });
    }
    if(jQuery('.title-sameheight').length > 0) {
        sameHeight(jQuery('.title-sameheight'));
    }
};

/**
 * Function called to set the height equal for objects passed.
**/
function sameHeight(jQueryobjects) {
    jQuery(window).bind("resize", { cachedObjects: jQueryobjects }, function (e) {
        let jQuerycachedObjects = e.data.cachedObjects;
        sameHeightSet(jQuerycachedObjects);
    }).trigger("resize");
}

function sameHeightSet(jQuerycachedObjects) {
    let max = -1;
    let h = 0;

    jQuerycachedObjects.css({ minHeight: 0 });
    jQuerycachedObjects.each(function () {
        h = jQuery(this).height();
        max = h > max ? h : max;
    });

    jQuerycachedObjects.each(function () {
        jQuery(this).css({ minHeight: max });
    });
}

function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    let arrLeonardGTMTrackingCTA = [];
    
    for (let i = 0; i < arrLeonardGTMTrackingFormPath.length; i++) {
        arrLeonardGTMTrackingCTA.push("a.btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.button[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }

    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");

    jQuery(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");

    // Track «Leads form» submit button click
    // -------
    if (arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
        jQuery("form button, form input[type=submit]").addClass("gtm-form-submited");
    }

    // Custom CTA tracking here	
    // --------
    var breadcrumbLink = jQuery("#breadcrumbs");
    var magazinesLink = jQuery("a[href*='https://abonnement.magazinevert.com/']");

    // Add gtm class dynamically
    addGTMClass(breadcrumbLink, 'gtm-breadcrumbs');
    addGTMClass(magazinesLink, 'gtm-cta-5');
}

// Add gtm class dynamically
function addGTMClass(element, gtmClass) {
    if (element.length) {
        element.addClass(gtmClass);
    }
}

function djdmvChangeViewerImage() {
    let taxonomyContent = jQuery(this).html();
    let taxonomyUrl = jQuery(this).data('url');
    let taxonomySrc = jQuery(this).children('img').attr('src');

    jQuery('.archive-inspiration-container').removeClass('active-viewer');

    jQuery(this).addClass('active-viewer');
    jQuery(this).closest('.archive-post').find('.taxonomy-viewer').empty().append(taxonomyContent);
    jQuery(this).closest('.archive-post').find('.stretched-link').attr('href', taxonomyUrl);
    jQuery(this).closest('.archive-post').find('.icon-arrow-right').attr('href', taxonomyUrl);
    jQuery(this).closest('.archive-post').find('.social-facebook').attr('href', baseFacebookShare + taxonomyUrl);

    if(jQuery('.social-pinterest').length > 0) {
        jQuery(this).closest('.archive-post').find('.social-pinterest').attr('href', basePinterestShare + '&url=' + taxonomyUrl + '&media=' + taxonomySrc);
    }
    else {
        jQuery(this).closest('.archive-post').find('.share-socials').append('<a class="icon icon-pinterest social-pinterest" target="_blank" rel="noopener" data-pin-do="buttonPin" data-pin-tall="true" data-pin-round="true" href="https://www.pinterest.com/pin/create/button/?description=Prochain%20arr%C3%AAt%3A%20Pinterest&url=' + taxonomyUrl + '&media=' + taxonomySrc + '"></a>');
    }

    if(jQuery('.social-email').length > 0) {
        jQuery(this).closest('.archive-post').find('.social-email').attr('href', 'mailto:?subject=Voici un lien à partager&amp;body=Veuillez prendre connaissance de ce lien:' + taxonomyUrl);
    }
    else {
        jQuery(this).closest('.archive-post').find('.share-socials').append('<a class="icon icon-email social-email" target="_blank" title="Courriel" href="mailto:?subject=Voici un lien à partager&amp;body=Veuillez prendre connaissance de ce lien:' + taxonomyUrl + '"><span class="hidden">Courriel</span></a>');
    }
}

/**
 * Called on anchor links with the "anchor-navigation" class. Makes an inner page navigation based ton the links href
 * @param {*} e 
 */
function djdmvAnchorNavigation(e) {
    e.preventDefault()
    let target_id = jQuery(this).attr('href');
    jQuery("html, body").animate({ scrollTop: jQuery(target_id).offset().top - jQuery('header').height() - 10 }, 1000);
}

function djdmvChangeMenuOnScroll() {
    let windowWidth = jQuery(window).width();

    if(windowWidth >= 1024) {
        const currentScroll = jQuery(window).scrollTop();

        if (currentScroll <= 0) {
            jQuery('body').removeClass('scrollUp');
            return;
        }

        if (currentScroll > lastScroll && jQuery('body').hasClass('scrollDown') == false) {
            jQuery('body').removeClass('scrollUp').addClass('scrollDown');
        }
        else if (currentScroll < lastScroll && jQuery('body').hasClass('scrollDown')) {
            jQuery('body').removeClass('scrollDown').addClass('scrollUp');
        }

        lastScroll = currentScroll;
    }
}

function openInspirationModal() {
    if(jQuery('.inspirationModal .modal-slider').length > 0 && !jQuery('.inspirationModal .modal-slider').hasClass('slick-slider')) {
        jQuery('.inspirationModal .modal-slider').slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            initialSlide: jQuery(this).data('slide'),
            prevArrow: '<a class="slick-nav slick-prev"><span class="arrow"></span></a>',
            nextArrow: '<a class="slick-nav slick-next"><span class="arrow"></span></a>'
        });
    }

    jQuery(document).mouseup(function(e){
        var container = jQuery('.inspirationModal .modal-slider');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            jQuery(document).unbind('mouseup');

            jQuery('.inspirationModal').toggleClass('hidden');
            jQuery('body').toggleClass('modalOpen');
    
            jQuery('.inspirationModal .modal-slider').slick('unslick');
        }
    });

    jQuery('body').toggleClass('modalOpen');
    jQuery('.inspirationModal').toggleClass('hidden');
}